import { API, App, useAPIQuery } from "core/api";

export function useFetchSelfCareApp(appConfigId?: string) {
  return useAPIQuery<App>(["apps"], API.config.app, {
    pathParams: {
      appConfigId: appConfigId ?? "-1",
    },
  });
}
